import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { OTPEnum } from "../../api";
import { getEnumKeys } from "../utils";

export interface OTPEnumListProps {
  value?: OTPEnum;
  onChange?: (value: OTPEnum) => void;
};

export const OTPEnumList = (props: OTPEnumListProps) => {
  const { value: method, onChange } = props;

  const handleChange = (value: string) => {
    if (onChange) onChange(value as OTPEnum);
  };

  return (
    <FormControl>
      <InputLabel id="otp-enum-list-label">OTP</InputLabel>
      <Select labelId="otp-enum-list-label" label="OTP" value={method || OTPEnum.None} onChange={(e) => handleChange(e.target.value)}>
        {getEnumKeys(OTPEnum).map((key, index) => {
          return (
            <MenuItem value={OTPEnum[key]} key={index}>
              {key}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
